import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';

import UserAvatar from './UserAvatar';

const UserGroup = ({ className, size = 'size4', total = [], users = 5 }) => {
  if (users.length < 0) {
    return null;
  }

  return (
    <div className={twMerge('flex', className)}>
      {users.map(({ userId, userPhoto, userName }, index) =>
        index > total ? null : (
          <UserAvatar
            key={userId}
            className={index > 0 && '-ml-2'}
            loading="lazy"
            size={size}
            style={{ zIndex: total - index }}
            userId={userId}
            userName={userName}
            userPhoto={userPhoto}
          />
        )
      )}
    </div>
  );
};

UserGroup.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  size: PropTypes.string,
  total: PropTypes.number,
  users: PropTypes.arrayOf(
    PropTypes.shape({
      userPhoto: PropTypes.string,
      userId: PropTypes.number.isRequired,
      userName: PropTypes.string,
    })
  ),
};

export default UserGroup;
